<header>
  <div class="header-container">
    <h1 [innerHTML]="title">{{ title }}</h1>
    <p *ngIf="subtitle">{{ subtitle }}</p>
  </div>
</header>
